import { combineReducers } from '@reduxjs/toolkit';
import authReducer from '../modules/auth/authenticationSlice';
import userMenuReducer from '../modules/auth/userMenuSlice';
import tabsReducer from '../modules/auth/tabsSlice';
import userOtherPrivilegesReducer from '../modules/auth/userOtherPrivilegesSlice';


const rootReducer = combineReducers({
    auth: authReducer,
    userMenus: userMenuReducer,
    tabs: tabsReducer,
    userOtherPrivileges: userOtherPrivilegesReducer,
});

export default rootReducer;


//authentication and authorization